import {
    dataURLtoFile,
    RaikoButtonPrimary,
    RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    RaikoMaterialOutlinedInput, RaikoSectionContainer,
    RaikoSimpleMultiLineInputOutlined, showErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import UploadPhoto from "../../component/UploadPhoto/UploadPhoto";
import React, {useState} from "react";
import {css} from "@emotion/css";
import {stringIsEmpty} from "../../util/VariableChecker";
import {ChartsService} from "../../serverService/charts/ChartsService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import UploadThumbnail from "../../component/uploadThumbnail/UploadThumbnail";

export default function SiteCreateChart({handleAddChartToTable}) {

    const service = new ChartsService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [photoFile, setPhotoFile] = useState([])
    const [photoUrl, setPhotoUrl] = useState([]);

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("")

    function handleCreateNewChart() {
        if (checkFields()) {
            loading.show()
            service.createNewChart(
                title,
                description,
                photoFile[0]
            ).then(response => {
                showSuccessMessage("نمودار جدید با موفقیت ساخته شد.")
                handleAddChartToTable(response)
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function checkFields() {
        let state = false
        let message

        if (!photoFile || photoFile.length === 0)
            message = "لطفا تصویر اسلایدر را وارد نمایید."
        else if (stringIsEmpty(title))
            message = "لطفا عنوان اسلایدر را وارد نمایید."
        else
            state = true

        if (message)
            showWarningMessage(message)

        return state
    }

    const handleSelectImage = (imgSrc, fileName) => {
        const imageFile = dataURLtoFile(imgSrc, fileName)
        setPhotoUrl(imgSrc)
        setPhotoFile(imageFile)
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoSectionContainer
                title={"تصویر شاخص"}
            >
                <UploadThumbnail
                    avatarFile={photoUrl}
                    updateAvatar={handleSelectImage}
                    loading={false}
                    aspectRatio={120 / 63}
                />
            </RaikoSectionContainer>
            <RaikoMaterialOutlinedInput
                labelText={"عنوان"}
                value={title}
                setValue={setTitle}
            />
            <RaikoSimpleMultiLineInputOutlined
                labelText={"توضیحات"}
                value={description}
                setValue={setDescription}
            />

            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary
                    label={"افزودن"}
                    onClick={handleCreateNewChart}
                />
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}
